import React, { useRef, useState } from "react";
import { Slide, Fade } from 'react-awesome-reveal';
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { sendBookDemoEmailAPI } from "../../../WebApp/Api/WebsiteServices/websiteService";
import { Toast } from "primereact/toast";

const JoinUs: React.FC = () => {
    const toast = useRef<Toast>(null);

    /* *********************************** For Joining form *********************************** */
    const [joinEmail, setJoinEmail] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);


    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const validateEmail = (): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!joinEmail.trim()) {
            setEmailError("Please provide the email address.");
            setShowInfoModal(true);
            setTimeout(() => {
                setShowInfoModal(false);
            }, 2000);
            return false;
        }

        if (!emailRegex.test(joinEmail.trim())) {
            setEmailError("Please provide a valid email address.");
            setShowInfoModal(true);
            setTimeout(() => {
                setShowInfoModal(false);
            }, 2000);
            return false;
        }

        setEmailError("");
        return true;
    };

    // Get api error messages
    function getApiErrorJoinUs(keyName: string, error: string): void {
        if (keyName === "email") {
            setEmailError(error);
        }
    }

    const handleJoinUs = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateEmail()) {
            return;
        }

        setLoading(true);

        try {
            const response = await sendBookDemoEmailAPI(
                joinEmail,
            );

            if (response?.statusCode === 200) {
                setSuccessMessage("Thank you for joining Traqdo! Your free trial request has been received. Get ready to experience smarter project management—we’ll be in touch with you shortly!");
                setShowAlert(true);
                setJoinEmail('');
                setEmailError("");

                setTimeout(() => {
                    setSuccessMessage("");
                    setShowAlert(false);
                }, 5000);
            } else if (response?.statusCode === 422) {
                Object.entries(response.errors ?? []).map(([key, value], index) =>
                    getApiErrorJoinUs(key, value[0])
                );
            } else {
                toast?.current?.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'An error occurred. Please try again later.',
                    life: 3000
                });
            }
        } catch (error) {
            toast?.current?.show({
                severity: 'error',
                summary: 'Failed',
                detail: 'An error occurred. Please try again later.',
                life: 3000
            });
        } finally {
            setLoading(false);
        }
    }
    /* **************************************************************************************** */

    return (
        <React.Fragment>
            <section className="join_us_section">
                <Fade delay={100} triggerOnce>
                    <article className="join_us_container section__padding">
                        <div className="container-md">
                            <div className="join_us_content">
                                <Fade delay={100} triggerOnce>
                                    <h2 className="section_main_head text-center text_bold text-white mb-0">
                                        Book Your Free Demo
                                    </h2>
                                </Fade>

                                <Slide direction="up" delay={100} triggerOnce>
                                    <p className="section_main_desc text-center text-white mb-0">
                                        Experience the future of construction project management firsthand. Book your free demo with Traqdo and discover how our innovative tools can simplify your workflow, boost team collaboration, and drive project success. See Traqdo in action and explore how it can transform the way you work.
                                    </p>
                                </Slide>

                                <Slide direction="up" delay={100} triggerOnce>
                                    <div className="join_us_form_section">
                                        <InputText
                                            value={joinEmail}
                                            className="join_us_input"
                                            placeholder="Type your email"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setJoinEmail(e.target.value)}
                                            keyfilter={'email'}
                                        />
                                        <button className="is_btn join_us_btn p-ripple" type="button"
                                            onClick={handleJoinUs}>
                                            {loading && (<ProgressSpinner strokeWidth="6" animationDuration="0.8s" />)}
                                            Book
                                            <Ripple />
                                        </button>
                                    </div>
                                </Slide>
                            </div>
                        </div>
                    </article>
                </Fade>
            </section>

            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box blurred ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message text-dark font_weight_normal">
                            {successMessage}
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}

            <Dialog headerClassName="d-none" dismissableMask
                visible={showInfoModal} className="custom_modal_dialog modal_dialog_sm"
                onHide={() => { if (!showInfoModal) return; setShowInfoModal(false); }}>
                <div className="custom_modal_body">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowInfoModal(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>

                    <h6 className="review_head text-center">Error!</h6>
                    <p className="review_paragraph text-center">
                        {emailError}
                    </p>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default JoinUs;